import React, { useEffect, useState } from 'react';
import routes from './routes';
import { Route, Switch, withRouter } from 'react-router-dom';
import Header from '../components/Header';
import '../stylesheets/base.scss';
import '../utilities/api';
import '../utilities/cookie';
import '../utilities/validation';
import '../utilities/generic';
import '../utilities/timezoneoffset';
import SiteFooter from '../components/SiteFooter';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import {
  COOKIE_DEFAULT_EXPIRY_TIME,
  COOKIE_EXPIRY_24HRS,
  STICKY_BANNER_CLOSE,
  STICKY_BANNER_COUNTER
} from '../constants/defaults';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { getUserPoints, logoutClearStore } from '../actions/auth';
import NotFound from '../components/NotFound/index.jsx';
import {
  GOOGLE_ADS_AUTO_RESIZE_SCRIPT,
  GOOGLE_ADS_AUTO_RESIZE_SCRIPT_WITH_TIMEOUT,
  GOOGLE_ADS_VARIABLE
} from '../constants/gptHeadTags/common';
import IdleTimer from '../components/common/IdleTimer';
import StickyAppPromoBanner from '../components/StickyAppPromoBanner';
import { SessionExpiredModal } from '../components/InActiveSession/SessionExpiredModal';
import { EXCLUDED_SEO_FOR_TIMEOUT } from '../constants/gptHeadTags/drugPage.js';
import { AuthContext, authinitialState } from '../Contexts.js';
const { API } = require('../config/' + process.env.REACT_APP_ENV);

const App = props => {
  /*
   * - this if condition is to handle logout user on client. when we click on logout there is no backend call
   *   and we not refresh page, so on client always get "userFname" which is from server, and user is
   *   logout on client which store in redux
   * - here we check "fname" is not available in cookie and user is  "logged in" on client, then make
   *   "repos" (ssr data) empty
   * */
  let repos;
  if (typeof __INITIAL_DATA__ !== 'undefined') {
    repos = window.__INITIAL_DATA__;
  } else {
    repos = !_.isUndefined(props.staticContext) && props.staticContext.data;
  }

  const determineUserLang = (path = null) => {
    const { i18n } = props;
    let lang = i18n.language;
    if (path !== null) {
      const urlLang = path.trim().split('/')[1];
      if (urlLang && urlLang === 'es' && urlLang !== lang) {
        lang = urlLang;
        i18n.changeLanguage(lang);
        urlLang !== 'loggedOut' &&
          _.setCookie('LocalLang', lang, COOKIE_DEFAULT_EXPIRY_TIME);
      }
      return lang;
    }
  };

  const [userPoints, setUserPoints] = useState({ amount: 0.0 });
  const [isFamilywizeBanner, setIsFamilywizeBanner] = useState(false);
  const [zipCodeUpdate, setZipCodeUpdate] = useState('');
  const [isBannerOpen, setIsBannerOpen] = useState(false);
  const [userName, setUserName] = useState(repos?.userFname);
  const [isServerSessionEnd, setIsServerSessionEnd] = useState(false);
  const [userData, setUserData] = useState(repos?.userData || authinitialState);
  const [language] = useState(determineUserLang(props.location.pathname));
  let isMobileDevice = false;
  if (_.has(repos, 'isMobileDevice')) {
    isMobileDevice = repos?.isMobileDevice;
  }

  const setPoints = async () => {
    if (userData?.isLoggedIn) {
      setUserName(userData.firstName);
      if (
        _.isUndefined(props.userStorePoints) ||
        _.isEmpty(props.userStorePoints) ||
        _.has(props.userStorePoints, 'isFromApi')
      ) {
        props.setUserPoint(props?.userData?.prospectId);
      } else {
        setUserPoints(props.userStorePoints);
      }
    }
  };

  useEffect(() => {
    _.setTimezoneCookie();
    if (repos && repos.userData) {
      setUserData(repos.userData);
    }
    if (repos && repos.isStickyBanner) {
      setIsBannerOpen(repos.isStickyBanner);
    }
    if (
      repos &&
      !_.isUndefined(repos.userFname) &&
      !_.isEmpty(repos.userFname)
    ) {
      setUserName(repos.userFname);
    }
    if (_.isEmpty(repos.userFname)) {
      if (!_.isEmpty(props.userData)) {
        props.clearUserData();
        setIsServerSessionEnd(true);
        setUserName('');
      }
    }
    const urlParams = new URLSearchParams(
      typeof window !== 'undefined' && window.location.search
    );
    if (urlParams && urlParams.has('isSessionInvalid')) {
      setIsServerSessionEnd(true);
    }
    _.triggerIntellimize();
    _.triggerGTMPageEvent();
    props.history.listen(() => {
      _.triggerIntellimize();
      _.triggerGTMPageEvent();
      setPoints();
    });
    _.triggerIntellimize();
    setPoints();
    if (
      props.location.hash === '#fw' ||
      sessionStorage.getItem('showFWBanner') === 'true'
    ) {
      setIsFamilywizeBanner(true);
    }
    window.addEventListener('keyup', handleKeydownEvent);
    window.addEventListener('mousedown', handleMousedownEvent);
    return () => {
      window.removeEventListener('keyup', handleKeydownEvent);
      window.removeEventListener('mousedown', handleMousedownEvent);
    };
  }, []);

  /*useEffect(() => {
    window.scroll({ top: 0 });
  }, [props.location]);*/

  useEffect(() => {
    if (
      props?.userStorePoints?.amount !== undefined &&
      props?.userStorePoints?.amount !== 0
    )
      setPoints();
  }, [props.userStorePoints]);

  const handleKeydownEvent = (event = { preventDefault() {} }) => {
    if (event.key === 'Tab') {
      _.setIsKeyboardUser(true, event);
    }
  };

  const handleMousedownEvent = (event = { preventDefault() {} }) => {
    _.setIsKeyboardUser(false, event);
  };

  const onLogOut = () => {
    //setUserPoints({});
    setUserName('');
    setUserData(authinitialState);
  };

  const closeFamilywizeBanner = () => {
    sessionStorage.removeItem('showFWBanner');
    setIsFamilywizeBanner(false);
  };

  const clearReduxData = async () => {
    await props.clearUserData();
    setIsServerSessionEnd(false);
    setUserName('');
    setUserData(authinitialState);
    props.i18n.language === 'es'
      ? window.location.assign('/es')
      : window.location.assign('/');
  };

  /**
   * set cookie if banner close by user and set expiry by 24hour and close the banner.
   */
  const handleCloseStickyBanner = () => {
    _.setCookie(STICKY_BANNER_CLOSE, true, COOKIE_EXPIRY_24HRS);
    _.eraseCookie(STICKY_BANNER_COUNTER);
    setIsBannerOpen(false);
  };

  const getGPTResizeCode = pathname => {
    if (!API?.ALLOW_TIMEOUT_ON_ADS_FOR_INTELLIMIZE || !pathname) {
      return GOOGLE_ADS_AUTO_RESIZE_SCRIPT;
    }

    // Trim and split pathname for checking page and excluded pages
    const route = pathname.trim().split('/');

    // Check if route matches the prescription and exclued seoNames
    if (
      route[1] === 'prescription' &&
      !EXCLUDED_SEO_FOR_TIMEOUT.includes(route[2]) &&
      route[3] == undefined
    ) {
      return GOOGLE_ADS_AUTO_RESIZE_SCRIPT_WITH_TIMEOUT;
    }

    // Default case: return regular script
    return GOOGLE_ADS_AUTO_RESIZE_SCRIPT;
  };
  return (
    <div
      className={`${
        isFamilywizeBanner ? 'bannerAddPadding' : 'bannerRemovePadding'
      }`}
    >
      <Helmet>
        <script
          async="async"
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
          type="text/plain"
          className="optanon-category-C0001"
        />
        <script>{GOOGLE_ADS_VARIABLE}</script>
        <script>{getGPTResizeCode(props?.location?.pathname)}</script>
        <meta property="environment" content={process.env.REACT_APP_ENV} />
        <meta property="logged_in" content={userData?.isLoggedIn} />
      </Helmet>
      <div
        className={`${language === 'es' ? 'spanish' : 'english'} ${
          isBannerOpen ? 'hersectionMainAB' : ''
        }`}
      >
        {isBannerOpen && (
          <div className="stickyAppPromoBanner">
            <StickyAppPromoBanner closeBanner={handleCloseStickyBanner} />
          </div>
        )}
        <AuthContext.Provider value={{ userData, setUserData }}>
          <Header
            userPoints={userPoints}
            onLogOut={onLogOut}
            isFamilywizeBanner={isFamilywizeBanner}
            setFamilywizeBanner={closeFamilywizeBanner}
            userName={userName}
            isUserLogin={userData?.isLoggedIn}
            isMobileDevice={isMobileDevice}
            toggleZipcode={setZipCodeUpdate}
          />
          <div id="scBanner"></div>
          {!repos.notFound ? (
            <Switch>
              {routes.map(({ path, exact, component: Component, ...rest }) => (
                <Route
                  key={path}
                  path={path}
                  exact={exact}
                  render={props => (
                    <Component
                      {...props}
                      {...rest}
                      userPoints={userPoints}
                      userName={userName}
                      zipcodeUpdated={zipCodeUpdate}
                      isMobileDevice={isMobileDevice}
                      onLogOut={onLogOut}
                    />
                  )}
                />
              ))}
            </Switch>
          ) : (
            <NotFound />
          )}
          {!_.isEmpty(userName) && <IdleTimer onLogOut={onLogOut} />}
          {(isServerSessionEnd || props.isServerSessionExpired) && (
            <SessionExpiredModal clearData={clearReduxData} />
          )}
          <SiteFooter userName={userName} />
        </AuthContext.Provider>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setUserPoint: mProspectId => dispatch(getUserPoints(mProspectId)),
    clearUserData: () => dispatch(logoutClearStore())
  };
};

function mapStateToProps(state) {
  return {
    userStorePoints: state.authentication.userPoints,
    isServerSessionExpired: state.authentication.isServerSessionExpired
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App))
);
